import { render, staticRenderFns } from "./PortfolioElement.vue?vue&type=template&id=7f030ee7&scoped=true&"
import script from "./PortfolioElement.vue?vue&type=script&lang=js&"
export * from "./PortfolioElement.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioElement.vue?vue&type=style&index=0&id=7f030ee7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f030ee7",
  null
  
)

export default component.exports